import {useEffect, useRef} from 'react';

export const useUpdateEffect = (func, target) => {
  const isInitialMount = useRef(true);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    func();
  }, target);
};
